/**
 * Created by MinhQuan on 3/14/2016.
 */
angular.element(document).ready(function() {
	
	var initInjector = angular.injector(['ng']);
	var $http = initInjector.get('$http');
	var initConfig = function(data) {
		
		angular.module('common.config', []).constant('CONSTANTS', data);
		angular.bootstrap(document, ["arctic.tariff"]);
	};
	
	$http({
	    url: 'config.json' + '?d=' + Date.now(),
	    method: 'GET',
	    headers: { 'Content-Type': 'application/json; charset=UTF-8' }
	}).then( function (response) {
		initConfig(response.data);
	});
});


// WEBPACK FOOTER //
// ./app/common/config/config.js